import type { JSX } from "react";
import { cn } from "../../lib/utils";

interface HeroLogoProps {
  src?: string;
  alt?: string;
  /** White turns a one-colour mark white, so a logo like "As seen on This Old House" reads on a dark overlay. */
  color?: "original" | "white";
  centered: boolean;
}

/** A featured logo under the hero's buttons ("As seen on", an award, a certification). Nothing without an image. */
const HeroLogo = ({ src, alt, color = "original", centered }: HeroLogoProps): JSX.Element | null => {
  if (src === undefined || src.trim() === "") {
    return null;
  }
  return (
    <div className={cn("jobsite:mt-8 jobsite:flex", centered ? "jobsite:justify-center" : "jobsite:justify-start")}>
      <img
        src={src}
        alt={alt ?? ""}
        data-testid="hero-logo"
        loading="eager"
        className={cn(
          "jobsite:h-16 jobsite:w-auto jobsite:max-w-[280px] jobsite:object-contain jobsite:md:h-20",
          color === "white" && "jobsite:brightness-0 jobsite:invert",
        )}
      />
    </div>
  );
};

export type { HeroLogoProps };
export { HeroLogo };
